import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRestService } from '@motivforce/mx-library-angular';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { Certificate } from '../../model/course/certificate';
import { CertificationData } from '../../model/course/certification-data';

@Injectable({
  providedIn: 'root',
})
export class CertificationRestService {
  constructor(protected apiRestService: ApiRestService, private httpClient: HttpClient) {}

  getCertificates(): Observable<Certificate[]> {
    return this.apiRestService.get<Certificate[]>(`${environment.api.core.baseUrl}/members/certifications`);
  }

  loginClaim(loginId: string): Observable<any> {
    return this.apiRestService.post(`${environment.api.core.baseUrl}/members/certifications/login-claim`, {
      loginId,
    });
  }

  loginClaimCheck(): Observable<any> {
    return this.apiRestService.get(`${environment.api.core.baseUrl}/members/certifications/login-claimed-check`);
  }

  validateClaim(data: CertificationData): Observable<any> {
    return this.apiRestService.post(`${environment.api.core.baseUrl}/members/certifications/validate`, data);
  }

  syncCertificates(): Observable<void> {
    // fire-and-forget - dont use apiRestService as it handles error, which, in this case, we dont care about.
    return this.httpClient.get<void>(`${environment.api.core.baseUrl}/members/certifications/sync`);
  }
}
